import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=fc7ce4de&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc7ce4de')) {
      api.createRecord('fc7ce4de', component.options)
    } else {
      api.reload('fc7ce4de', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=fc7ce4de&", function () {
      api.rerender('fc7ce4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24SOmIuxubEzt/JS/comp/FavElement.vue"
export default component.exports